var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({ref:"collapseEl",staticClass:"collapse",attrs:{"id":_vm.id,"role":_vm.role,"data-testid":"bs-collapse"}},'div',_vm.parentAttr,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }